// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__C74LN"};